import React, { Component, Fragment } from "react";
import User_panel from "./user-panel";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// Action import
import { change_Lang } from "../../../actions/Helper_action";
import { isUserLoggedIn, LogOut } from "../../../actions/Auth_action";
import {
  Get_List_Rent_Property,
  Get_List_Required_Property,
  Get_List_Required_Property_Rent,
  Get_List_Sell_Property,
} from "../../../actions_agent/Property_action";
import {
  Get_List_Rent_Contracts,
  Get_List_Sell_Contracts,
  Get_List_Take_Money,
  Get_List_Tanents,
} from "../../../actions_agent/Invoice_action";
import { isMobile } from "react-device-detect";
import { MENUITEMS_AGENT } from "../../../constants/menu2";
import { MENUITEMS_ACCOUNTANT } from "../../../constants/menu3";
export class Sidebar_Agent extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      selectedPath: "1",
      mainmenu:
        user.role === "accountant" ? MENUITEMS_ACCOUNTANT : MENUITEMS_AGENT,
      sidebar: true,
    };
  }

  componentDidMount() {
    // const { isUserLoggedIn } = this.props;
    // isUserLoggedIn();
    if (window.innerWidth < 769) {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
    var currentUrl = window.location.pathname;

    this.state.mainmenu.filter((items) => {
      if (!items.children) {
        if (items.path === currentUrl) this.setNavActive(items);
        return false;
      }
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) this.setNavActive(subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) this.setNavActive(subSubItems);
        });
      });
    });
  }
  RemoveSidebar = () => {
    if (this.state.sidebar) {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      this.setState({ sidebar: false });
    } else {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      this.setState({ sidebar: true });
    }
  };
  setNavActive(item) {
    const { user } = this.props;
    if (user.role === "accountant") {
      MENUITEMS_ACCOUNTANT.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;

      this.setState({
        mainmenu: MENUITEMS_ACCOUNTANT,
      });
    } else {
      MENUITEMS_AGENT.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;

      this.setState({
        mainmenu: MENUITEMS_AGENT,
      });
    }
  }
  render() {
    const { Change_Lang } = this.props;

    const mainmenu = this.state.mainmenu.map((menuItem, i) => (
      <li className={`${menuItem.active ? "active" : ""}`} key={i}>
        {menuItem.sidebartitle ? (
          <div className="sidebar-title">{menuItem.sidebartitle}</div>
        ) : (
          ""
        )}
        {menuItem.type === "sub" ? (
          <a
            className="sidebar-header "
            href="#!"
            onClick={() => this.setNavActive(menuItem)}
          >
            <menuItem.icon style={{ color: "#6972f0" }} />
            <span>{Change_Lang(menuItem.title)}</span>
            <i className="fa fa-angle-right pull-right"></i>
          </a>
        ) : (
          ""
        )}
        {menuItem.type === "logout" ? (
          <a
            className="sidebar-header -cursor-pointer"
            onClick={() => {
              this.setNavActive(menuItem);
              //  this.props.Logout();
            }}
          >
            <menuItem.icon />
            <span className="-cursor-pointer">
              {Change_Lang(menuItem.title)}
            </span>
          </a>
        ) : (
          ""
        )}
        {menuItem.type === "link" ? (
          <Link
            to={`${menuItem.path}`}
            className={`sidebar-header ${menuItem.active ? "active" : ""}`}
            onClick={() => this.setNavActive(menuItem)}
          >
            <menuItem.icon />
            <span>{Change_Lang(menuItem.title)}</span>
            {menuItem.children ? (
              <i className="fa fa-angle-right pull-right"></i>
            ) : (
              ""
            )}
          </Link>
        ) : (
          ""
        )}
        {menuItem.children ? (
          <ul
            className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}
            style={
              menuItem.active
                ? { opacity: 1, transition: "opacity 500ms ease-in" }
                : {}
            }
          >
            {menuItem.children.map((childrenItem, index) => (
              <li
                key={index}
                className={
                  childrenItem.children
                    ? childrenItem.active
                      ? "active"
                      : ""
                    : ""
                }
              >
                {childrenItem.type === "sub" ? (
                  <a href="#!" onClick={() => this.setNavActive(childrenItem)}>
                    <i className="fa fa-circle"></i>
                    {Change_Lang(childrenItem.title)}{" "}
                    <i className="fa fa-angle-right pull-right"></i>
                  </a>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "link" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang(childrenItem.title)}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "link" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang(childrenItem.title)}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "Rent Property List" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Rent_Property();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Rent Property List")}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Rent Property List" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Rent_Property();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Rent Property List")}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "logout_sub" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Logout();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("s_logout")}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "logout_sub" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Logout();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("s_logout")}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "Sell Property List" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Sell_Property();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Sell Property List")}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Sell Property List" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Sell_Property();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Sell Property List")}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "Buy Required Property" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Required_Property();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Buy Required Property")}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Buy Required Property" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Required_Property();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Buy Required Property")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "Sell Contracts" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Sell_Contracts();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Sell Contracts")}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Sell Contracts" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Sell_Contracts();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Sell Contracts")}{" "}
                  </Link>
                ) : (
                  ""
                )}{" "}
                {isMobile !== true ? (
                  childrenItem.type === "Rent Contracts" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Rent_Contracts();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Rent Contracts")}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Rent Contracts" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Rent_Contracts();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Rent Contracts")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "List of Tenants" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Tanents();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("List of Tenants")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "list taking money" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Take_Money();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("list taking money")}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "list taking money" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Take_Money();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("list taking money")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {isMobile !== true ? (
                  childrenItem.type === "Rent Required Property" ? (
                    <Link
                      to={`${childrenItem.path}`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        this.props.Get_List_Required_Property_Rent();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Rent Required Property")}{" "}
                    </Link>
                  ) : (
                    ""
                  )
                ) : childrenItem.type === "Rent Required Property" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Required_Property_Rent();
                      this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Rent Required Property")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.children ? (
                  <ul
                    className={`sidebar-submenu ${
                      childrenItem.active ? "menu-open" : "active"
                    }`}
                  >
                    {childrenItem.children.map((childrenSubItem, key) => (
                      <li
                        className={childrenSubItem.active ? "active" : ""}
                        key={key}
                      >
                        {childrenSubItem.type === "link" ? (
                          <Link
                            to={`${childrenSubItem.path}`}
                            className={childrenSubItem.active ? "active" : ""}
                            onClick={() => this.setNavActive(childrenSubItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {Change_Lang(childrenSubItem.title)}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        ) : (
          ""
        )}
      </li>
    ));
    const { user } = this.props;
    return (
      <Fragment>
        <div
          className={`${
            this.props.lang === "en" ? "page-sidebar" : "page-sidebar fk"
          }`}
        >
          <div className="main-header-left d-none d-lg-block">
            <div className="logo-wrapper justify-content-center mt-1">
              <Link to={`/dashboard`}>
                {/* <img className="" 
        style={{width:"120px",height:"60px",borderRadius:"10px"}}
         src={`/${user.realEstateId.image}`} alt="" /> */}
                <i
                  className="mr-1"
                  style={{ color: "#4064d7", fontFamily: "cursive" }}
                >
                  {this.props.isAuth !== null
                    ? `${user.fname}   ${user.lname}`
                    : ""}
                </i>
              </Link>
            </div>
          </div>
          <div className="sidebar custom-scrollbar">
            <User_panel />
            <ul className="sidebar-menu">{mainmenu}</ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    isAuth: state.AuthReducer.isAuth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Change_Lang: (key) => dispatch(change_Lang(key)),
    Logout: () => dispatch(LogOut()),
    Get_List_Sell_Property: () => dispatch(Get_List_Sell_Property()),
    Get_List_Rent_Property: () => dispatch(Get_List_Rent_Property()),
    Get_List_Required_Property_Rent: () =>
      dispatch(Get_List_Required_Property_Rent()),
    Get_List_Required_Property: () => dispatch(Get_List_Required_Property()),
    Get_List_Sell_Contracts: () => dispatch(Get_List_Sell_Contracts()),
    Get_List_Tanents: () => dispatch(Get_List_Tanents()),
    Get_List_Rent_Contracts: () => dispatch(Get_List_Rent_Contracts()),
    Get_List_Take_Money: () => dispatch(Get_List_Take_Money()),
    isUserLoggedIn: () => dispatch(isUserLoggedIn()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar_Agent);
